import { ImagesType } from "@features/images/type";

/**
 * Determines if the action grid should be shown based on image context
 */
export const shouldShowActionGrid = (image: ImagesType): boolean => {
  return image.type !== "video" && image.sub_type !== "upscale";
};
